module.exports = __webpack_public_path__ + "static/media/insurance.d3d1b098.svg";